import type * as ReplaceShoppingBagItem from '@ori-events/replace-shopping-bag-item';
import * as ReplaceShoppingBagItemFailed from '@ori-events/replace-shopping-bag-item-failed';
import type { PositionData } from '@ori/analytics-data';

import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';

type Data = PositionData & ReplaceShoppingBagItem.Data;

export async function replaceShoppingBagItemHandler({
  detail: { itemCode, lineNumber, placement },
}: CustomEvent<Data>) {
  const response = await fetch(
    `${RequestUrl.ReplaceShoppingBagItem}?lineNumber=${lineNumber}&itemCode=${itemCode}`,
    getHttpRequestSettings({ placement }),
  );
  const data = convertToCamelCase<ReplaceShoppingBagItemFailed.ReplaceShoppingBagItemResponse>(
    (await response.json()) as object,
  );

  if (ReplaceShoppingBagItemFailed.isReplaceShoppingBagItemErrorResponse(data)) {
    const errorEvent = new CustomEvent<ReplaceShoppingBagItemFailed.Data>(ReplaceShoppingBagItemFailed.Name, {
      detail: data,
    });
    window.dispatchEvent(errorEvent);

    return false;
  }

  return data;
}
